import React from 'react'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { OrderList } from '@/components/orders/OrderList'
import { useToast } from '@/hooks/use-toast'
import apiClient from '@/lib/apiClient'

const OrdersPage: React.FC = () => {
  const { toast } = useToast()
  const queryClient = useQueryClient()
  const navigate = useNavigate()

  const addNoteMutation = useMutation({
    mutationFn: async ({ orderId, note }: { orderId: string; note: string }) => {
      return apiClient.updateOrder(orderId, {
        notes: note,
        append_notes: true,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['orders'] })
      queryClient.invalidateQueries({ queryKey: ['orderStats'] })
      toast({
        title: 'Success',
        description: 'Note added to order successfully',
      })
    },
    onError: () => {
      toast({
        title: 'Error',
        description: 'Failed to add note. Please try again.',
        variant: 'destructive',
      })
    },
  })

  const handleViewOrder = (orderId: string) => {
    navigate(`/orders/${orderId}`)
  }

  const handleAddNote = async (orderId: string, note: string) => {
    addNoteMutation.mutate({ orderId, note })
  }


  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">Orders</h1>
        <p className="text-muted-foreground">
          Manage customer orders and fulfillment
        </p>
      </div>

      <OrderList
        onViewOrder={handleViewOrder}
        onAddNote={handleAddNote}
      />
    </div>
  )
}

export default OrdersPage
